import type { TwoFactorAuthenticationMethods as MFAMethods } from "@shared/types/graphqlGenerated";

import { useMfaSharedQuery } from "./MFA.query.generated";

interface MFAData {
  isMFAEnabled: boolean;
  isLocked: boolean;
  hasMultiPlatformWarning: boolean;
  otpMethod: MFAMethods;
  phoneLast4: string;
  email: string;
  emailMasked: string;
  loading: boolean;
}

const useMFAData = (): MFAData => {
  const { data, loading } = useMfaSharedQuery();
  const tfa = data?.currentUser?.twoFactorAuthentication;

  return {
    isMFAEnabled: tfa?.isEnabled as boolean,
    isLocked: tfa?.isLocked as boolean,
    hasMultiPlatformWarning: data?.currentUser?.hasMultipleStorePlatforms as boolean,
    otpMethod: tfa?.otpMethod as MFAMethods,
    phoneLast4: tfa?.phoneLast4 as string,
    email: tfa?.email as string,
    emailMasked: tfa?.emailMasked as string,
    loading,
  };
};

export { useMFAData };
